import styled, { keyframes } from 'styled-components'

import { hardcoreAnimationEase, media } from '../../../../../../utils/style-utils'
import BaseDoubleClaim from '../../../../../DoubleClaim'
import DoubleClaimWrapper from '../../../../../DoubleClaim/Wrapper'

interface Props {
  active: boolean
}

const animationIn = keyframes`
  from {
    transform: translateX(1000px);
  }
`

export const StyledDoubleClaim = styled(BaseDoubleClaim)`
  animation: ${animationIn} 0.5s ${hardcoreAnimationEase};
  ${({ active }: Props) => (!active ? 'animation: none' : '')};

  ${DoubleClaimWrapper.selector} {
    transform-origin: right;

    ${media.xxl`
      transform: scale(0.7);
    `}

    ${media.md`
      display: none;
    `}
  }
`
